export enum PlatformType {
  AZURE_CONTAINERS = 'azure_containers',
  AZURE_K8S = 'azure_k8s',
}
